import { Link, useLocation, useParams } from 'react-router-dom';
import {
  FaCirclePlay,
  FaListUl,
  FaServer,
  FaChartColumn,
  FaMapLocationDot,
  FaBoxOpen,
  FaUserMinus,
  FaAddressBook,
} from 'react-icons/fa6';
import clsx from 'clsx';

// Bouton d’onglet (navigue par <Link>)
function TabLink({ to, icon: Icon, label, active }) {
  return (
    <Link
      to={to}
      className={clsx(
        'relative inline-flex items-center gap-2 px-4 sm:px-5 py-2.5 rounded-xl text-sm font-medium transition-all border',
        active
          ? 'bg-stone-800 hover:bg-indigo-700 hover:text-white border-transparent text-white'
          : 'bg-slate-200  hover:bg-indigo-700 hover:text-white border-transparent text-gray-900'
      )}
      aria-pressed={active}
    >
      <Icon className="opacity-80" />
      {label}
      {active && (
        <span className="absolute inset-x-3 -bottom-0.5 h-0.5 rounded-full" />
      )}
    </Link>
  );
}

export default function AppHeader() {
  const location = useLocation();
  useParams();

  // Heuristique simple d’activation des onglets
  const isPlaylists =
    location.pathname === '/' || location.pathname.startsWith('/broadcasts');
  const isProviders = location.pathname.startsWith('/providers');
  const isProducts = location.pathname.startsWith('/products');
  const isUnsubscribes = location.pathname.startsWith('/admin/unsubscribes');
  const isGestion = location.pathname.startsWith('/gestion');

  return (
    // si vous avez une Navbar sticky au-dessus, remplacez top-0 par top-14/16/etc.
    <header className="sticky top-12 z-30 backdrop-blur bg-white/70 border-b border-slate-200">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-600 text-white shadow-sm">
            <FaCirclePlay />
          </span>
          <div>
            <div className="text-xs uppercase tracking-widest text-slate-400">
              Bibliothèque
            </div>
            <div className="font-semibold text-slate-900">
              Vos playlists & providers
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <TabLink
            to="/"
            icon={FaListUl}
            label="Playlists"
            active={isPlaylists}
          />
          <TabLink
            to="/providers"
            icon={FaServer}
            label="Providers SMTP"
            active={isProviders}
          />

          <Link
            to="/broadcasts/dashboard"
            className={clsx(
              'inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold',
              'bg-slate-200 text-gray-900 hover:bg-indigo-700 hover:text-white active:bg-black transition-shadow shadow-sm'
            )}
          >
            <FaChartColumn />
            Broadcast Dashboard
          </Link>

          {/* Bouton principal → navigation vers la page dédiée (plus de modal) */}
          <Link
            to="/playlists/new"
            className={clsx(
              'inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold',
              'bg-slate-200 text-gray-900 hover:bg-indigo-700 hover:text-white transition-shadow shadow-sm'
            )}
          >
            <FaMapLocationDot />
            Voir la carte
          </Link>

          <TabLink
            to="/products"
            icon={FaBoxOpen}
            label="Produits packagés"
            active={isProducts}
          />
          <TabLink
            to="/gestion"
            icon={FaAddressBook}
            label="Gestion DL"
            active={isGestion}
          />
          <TabLink
            to="/admin/unsubscribes"
            icon={FaUserMinus}
            label="Désabonnements"
            active={isUnsubscribes}
          />

          <Link
            to="/stats/bounces"
            className={clsx(
              'inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold',
              'bg-slate-200 text-gray-900 hover:bg-indigo-700 hover:text-white active:bg-black transition-shadow shadow-sm'
            )}
          >
            <FaChartColumn />
            Stats
          </Link>
        </div>
      </div>
    </header>
  );
}
